import { combineReducers } from 'redux';

import leftSidebar from './left-sidebar';
import appbar from './appbar';
import menubarReducer from './menubar';

const mainLayouts = combineReducers({
  leftSidebar,
  appbar,
  menubarReducer,
});

export default mainLayouts;
